// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__21nCC","wrapper":"Loader_wrapper__lcd85"};